import BaseDropdown, { DropdownItem as BaseDropdownItem } from "@common/components/Dropdown/Dropdown";
import Input from "@common/components/Input/Input";
import { vars } from "@common/styles";
import * as Icon from "@main/pages/shared/icons/icons";
import styled, { css } from "styled-components";

export const AssigneeDropdown = styled(BaseDropdown)`
  span {
    margin-right: 0;
  }
`;

export const DropdownAssigneeInput = styled(Input)`
  > * {
    background-color: ${vars.colors.grey100};
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid ${vars.colors.grey90};
    border-radius: 0;
    padding: 1.3rem 1.6rem;
    max-height: 6.4rem;

    &:hover {
      border-bottom: 1px solid ${vars.colors.grey90};
    }
  }
`;

export const DropdownItem = styled(BaseDropdownItem)<{ $clicked?: boolean }>`
  ${(props) =>
    props.$clicked &&
    css`
      background: ${vars.colors.grey90};
    `}

  p {
    color: ${vars.colors.grey50};
    max-width: 22rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const dropdownScroll = `max-height: 25rem;`;

export const Checkmark = styled.div`
  margin-right: 0.8rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
`;

export const CheckmarkIcon = styled(Icon.CheckmarkIcon)`
  path {
    stroke: ${vars.colors.white};
  }
`;
